<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component
          :is="Component"
          :key="route.path"
          v-if="route.meta.keepAlive"
        />
      </keep-alive>
      <component
        :is="Component"
        :key="route.path"
        v-if="!route.meta.keepAlive"
      />
    </router-view>
  </div>
</template>

<script setup>
import { reactive, toRefs, } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { getQueryString, setDocumentTitle } from '@/utils/common'

// eslint-disable-next-line
const store = useStore()
const router = useRouter()
const route = useRoute()
const state = reactive({
  transitionName: 'slide-left',
  // 需要全局路由传递的参数名字数组
  globalParameNameArr: ['urlToken', 'token', 'recordId', 'xibshowtopbar'],
})

// 需要全局路由的参数保存成对象形式
let wholeQuery = {}
state.globalParameNameArr.map(name => {
  let val = getQueryString(name)
  if (val) wholeQuery[name] = val
})

router.beforeEach((to, from, next) => {
  let { title, requiresAuth, } = to.meta
  const loginStatus = store.state.loginStatus // 登录状态:微信授权成功后设置为'1'
  // console.log(requiresAuth, loginStatus, store.state.loginStatus);
  if (to.name === 'Login') next()
  // 未登录页面重定向 
  if (requiresAuth && loginStatus !== '1') {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath,
      }, // 保存我们所在的位置，以便登录成功后跳转
    })
  } else {
    // 全局路由参数存在，但to.query的参数不存在，to.query加上全局路由参数
    if (Object.keys(wholeQuery).length > 0 && state.globalParameNameArr.some(name => wholeQuery[name] && !to.query[name])) { // 全局query
      let query = { ...wholeQuery, ...to.query }
      // console.log(wholeQuery, to.query, query);
      next({
        path: to.path,
        query
      })
    } else {
      next()
    }
  }
})

router.afterEach((to) => {
  window.scrollTo(0, 0)
  let { title, } = to.meta
  if (title) setDocumentTitle(title)

})




// return {
//   ...toRefs(state),
//   route,
// }
</script>

<style lang="less">
html,
body {
  width: 100%;
  height: 100%;
  // overflow-x: hidden;
  // overflow-y: scroll;
  overscroll-behavior: none;
}

#app {
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

.router-view {
  width: 100%;
  // height: auto;
  min-height: 100vh;
  height: fit-content;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch;
}

.van-badge--fixed {
  z-index: 1000;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
